import parse from 'html-react-parser'
import { formatEndDate } from '@components/Details/AuctionDetailInfo'

const InfoSlideOut = function ({ auction, open, setOpen }: any) {
  const { bidIncrements, terms, notes } = auction

  const sortedTerms = terms.sort((a: any, b: any) => a.ordinal - b.ordinal)
  const sortedNotes = notes.sort((a: any, b: any) => a.ordinal - b.ordinal)

  return (
    <div>
      {open ? (
        <div onClick={() => setOpen(false)}>
          <div className="justify-center flex overflow-x-hidden overflow-y-auto fixed top-20 md:top-30 inset-0 z-50 outline-none focus:outline-none">
            <div className="relative w-auto my-6 mx-auto max-w-4xl">
              {/*content*/}
              <div className="border-0 rounded-lg shadow-lg relative flex flex-col w-full bg-white outline-none focus:outline-none">
                {/*header*/}
                <div className="flex items-center justify-between p-5 border-b border-solid border-slate-200 rounded-t">
                  <h3 className="font-bold text-bidfta-gray-dark text-xl text-center">
                    Highlights
                  </h3>
                  <button
                    className="p-1 ml-auto bg-transparent border-0 text-black float-right text-3xl leading-none font-semibold outline-none focus:outline-none"
                    onClick={() => setOpen(false)}
                  >
                    x
                  </button>
                </div>
                {/*body*/}
                <div className={'p-4'}>
                  <AuctionInfo
                    sortedNotes={sortedNotes}
                    bidIncrements={bidIncrements}
                    sortedTerms={sortedTerms}
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-40 bg-black" />
        </div>
      ) : null}
    </div>
  )
}

const AuctionInfo = ({ sortedNotes, bidIncrements, sortedTerms }: any) => {
  return (
    <div>
      <p className="text-bidfta-red mb-4">
        Credit cards will be charged automatically after auction has ended.
        Please bring your receipt printed or pulled up on a mobile device with
        the QR code visible. If you do not pick-up items on scheduled removal
        date/time, your items are subject to disposal, resale or donation.
      </p>
      <h3 className="font-bold text-bidfta-gray-dark text-xl mb-2.5">Notes</h3>
      {sortedNotes.map((note: any) => (
        <div className="mb-4" key={note.id}>
          <span className="font-bold">{note.keyName}:</span>{' '}
          {parse(note.keyValue)}
        </div>
      ))}
      <h3 className="font-bold text-bidfta-gray-dark text-xl mb-2.5">
        Bid Increment
      </h3>
      <p className="mb-2.5">
        Items with the following icon{' '}
        <span className="inline-block rounded-full w-4 text-center bg-green text-white justify-center items-center text-xs">
          $
        </span>{' '}
        will have different bid increments. Please check items for adjusted
        bidding increment.
      </p>
      <table className="w-full md:w-7/12 mb-6">
        <thead className="text-white bg-bidfta-green-tabledark w-full py-1.5">
          <tr>
            <th className="text-left pl-1.5">From ($)</th>
            <th className="text-left">To ($)</th>
            <th>Increment ($)</th>
          </tr>
        </thead>
        <tbody>
          {bidIncrements.map((increment: any, i: any) => (
            <tr
              key={increment.id}
              className={` ${
                i % 2 === 0 ? 'bg-white' : 'bg-bidfta-green-tablelight'
              }`}
            >
              <td className="py-1.5 pl-1.5">{`$${increment.startValue.toFixed(
                2
              )}`}</td>
              <td>{`$${increment.endValue.toFixed(2)}`}</td>
              <td className="text-center">{`$${increment.increment.toFixed(
                2
              )}`}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <h3 className="font-bold text-bidfta-gray-dark text-xl mb-2.5">Terms</h3>
      {sortedTerms.map((term: any) => (
        <p className="mb-4" key={term.keyId}>
          <span className="font-bold">{term.keyName}:</span> {term.keyValue}
        </p>
      ))}
    </div>
  )
}

export default InfoSlideOut
